import React from "react";
import CustomTable from "..";
import { ColumnDef } from "@tanstack/react-table";

interface RowData {
  plan: string;
  status: string;
  createdOn: string;

}

export default function InvoiceTable() {
  const columns: ColumnDef<RowData>[] = [
    {
      accessorKey: "plan",
      header: "Plan",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "createdOn",
      header: "Created On",
      cell: (info) => info.getValue(),
    },
    

   
  ];

  const initialData: RowData[] = [
    {
      plan: "Premium",
      status: "Paid",
      createdOn: "19-02-2025 05:47 PM",
    },
    {
      plan: "Premium",
      status: "Paid",
      createdOn: "19-02-2025 05:47 PM",
    },
    {
      plan: "Premium",
      status: "Paid",
      createdOn: "19-02-2025 05:47 PM",
    },
    {
      plan: "Premium",
      status: "Paid",
      createdOn: "19-02-2025 05:47 PM",
    },
    {
      plan: "Premium",
      status: "Paid",
      createdOn: "19-02-2025 05:47 PM",
    },
    {
      plan: "Premium",
      status: "Paid",
      createdOn: "19-02-2025 05:47 PM",
    },

    {
      plan: "Premium",
      status: "Paid",
      createdOn: "19-02-2025 05:47 PM",
    },
    
    
     
  ];

  return <CustomTable columns={columns} initialData={initialData} />;
}
